import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'RADIOLOGISTA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'RADIOLOGISTA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('radiologistaForm', registro)
    ];
}

export function getLista(evento) {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/radiologista`).then(resp => {
			dispatch({
				type: 'RADIOLOGISTA_LISTADO',
				payload: resp
			});
			
			try {
				if (evento) {
					evento();
				}
			} catch(ex) {

			}
			
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro, evento) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/radiologista`, {
				...registro,
				cpf: FormatUtils.removerMascara(registro.cpf),
				crm: FormatUtils.removerMascara(registro.crm),
				telefone: FormatUtils.removerMascara(registro.telefone),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(evento));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/radiologista`, {
				...registro,
				cpf: FormatUtils.removerMascara(registro.cpf),
				crm: FormatUtils.removerMascara(registro.crm),
				telefone: FormatUtils.removerMascara(registro.telefone),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(evento));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/radiologista?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}